









































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ChooseDevice from "./watermeterchoice.vue";
import Moment from "moment-timezone";
import echarts from "echarts";

class PageMeterRequest extends PageRequest {
    keyword: string = "";
    startTime: string;
    endTime: string;
    deviceId: any[] = [];
    page: number;
    pageSize: number;
    sortBy: string = "gatherTime";
    descending: boolean = true;
    filterFileds: any;
    dataType: number = 1;
}

@Component({
    components: { ChooseDevice },
})
export default class EletricalParameters extends AbpBase {
    //filters
    pagerequest: PageMeterRequest = new PageMeterRequest();
    chooseModal: boolean = false; //选择窗体是否显示
    //choosemeters: Array<any> = []; //已经选择表计
    splitnum: number = 0.1;
    height: number = 230;
    loadingdata: boolean = false;
    paramscolumns: any[] = [];//已选择电参数
    usebar: any; //图表
    paramstype = 1;
    //显示选择表计框
    showchoosedevice() {
        this.chooseModal = true;
    }
    //获取子组件回传值
    getdevicelist(data: any) {
        this.pagerequest.deviceId = [];
        data.forEach((ele) => {
            this.pagerequest.deviceId.push(ele.id);
            this.pagerequest.keyword = ele.meterNo + '>>' + ele.roomNo;
        });
        this.getpage(this.paramstype);
    }
    cleardata() {
        this.pagerequest.deviceId = [];
    }
    //改变排序
    changeSort(key) {
        console.log(key)
        if (key.order === "desc" || key.order === "normal") {
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = true;
        } else {
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = false;
        }
        //console.log(this.pagerequest)
        this.getpage(this.paramstype);
    }
    get list() {
        //console.log(this.$store.state.monitor.list)
        return this.$store.state.waterparams.list;
    }
    get loading() {
        return this.$store.state.waterparams.loading;
    }
    isActiveChange(val: number) {
        this.$store.commit("waterparams/setCurrentPage", 1);
        this.getpage(this.paramstype);
    }
    pageChange(page: number) {
        this.$store.commit("waterparams/setCurrentPage", page);
        this.getpage(this.paramstype);
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("waterparams/setPageSize", pagesize);
        this.getpage(this.paramstype);
    }
    async getpage(params: number) {
        this.pagerequest.pageSize = this.pageSize;
        this.pagerequest.page = this.currentPage;
        this.pagerequest.dataType = params;
        //console.log(this.pagerequest)
        if (this.pagerequest.deviceId.length == 0 || this.pagerequest.deviceId.length > 1) {
            this.$Modal.warning({
                title: this.L("Tips"),
                content: this.L("ChooseMeters"),
            });
            return;
        }
        //console.log(this.pagerequest)
        await this.$store.dispatch({ type: "waterparams/getESRecordList", data: this.pagerequest, });
        this.getparams(params);
    }
    get pageSize() {
        return this.$store.state.waterparams.pageSize;
    }
    get totalCount() {
        return this.$store.state.waterparams.totalCount;
    }
    get currentPage() {
        return this.$store.state.waterparams.currentPage;
    }
    //列信息
    columns = [
        {
            type: "index",
            width: 70,
            align: "left",
            fixed: "left",
            key: "index",
            title: this.L("IndexNo"),
            sortId: 0,
        },
        {
            sortable: true,
            title: this.L("Meter"),
            key: "deviceNo",
            resizable: true,
            width: 100,
            fixed: "left",
            sortId: 2,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.deviceNo,
                        },
                    },
                    params.row.deviceNo
                );
            },
        },
        {
            title: this.L("LastReadTime"),
            key: "gatherTime",
            sortable: true,
            sortType: "desc",
            width: 150,
            //fixed: "right",
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.gatherTime == null
                        ? ""
                        : Moment(params.row.gatherTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        // {
        //     title: this.L("Organizations"),
        //     key: "organizationId",
        //     width: 130,
        //     resizable: true,
        //     sortId: 19,
        //     render: (h: any, params: any) => {
        //         let id = params.row.organizationId;
        //         let ite = JSON.parse(localStorage.getItem("organizations"));
        //         let info = ite.filter((p) => {
        //             return p.id == id;
        //         });
        //         return h("div", [
        //             h(
        //                 "span",
        //                 {
        //                     style: {
        //                         display: "inline-block",
        //                         width: "100%",
        //                         overflow: "hidden",
        //                         textOverflow: "ellipsis",
        //                         whiteSpace: "nowrap",
        //                     },
        //                     domProps: {
        //                         title:
        //                             info.length > 0 ? info[0].displayName : this.L("Unknown"),
        //                     },
        //                 },
        //                 info.length > 0 ? info[0].displayName : this.L("Unknown")
        //             ),
        //         ]);
        //     },
        // },
        {
            title: this.L("Areas"),
            key: "areaId",
            sortable: true,
            width: 100,
            resizable: true,
            sortId: 20,
            render: (h: any, params: any) => {
                let id = params.row.areaId;
                let ite = JSON.parse(localStorage.getItem("areas"));
                let info = ite.filter((p) => {
                    return p.id == id;
                });
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
                            },
                        },
                        info.length > 0 ? info[0].fullName : this.L("Unknown")
                    ),
                ]);
            },
        },
        {
            title: this.L("Instantaneousflowrate"),
            key: "instantaneousFlowRate",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.instantaneousFlowRate == null
                        ? ""
                        : parseFloat(params.row.instantaneousFlowRate).toFixed(2)
                );
            },
        },
        {
            title: "正向累计流量期初",
            key: "positiveLastRead",
            align: "center",
            width: 150,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.positiveLastRead == null
                        ? ""
                        : parseFloat(params.row.positiveLastRead).toFixed(2)
                );
            },
        },
        {
            title: "正向累计流量期末",
            key: "positiveThisRead",
            align: "center",
            width: 150,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.positiveThisRead == null
                        ? ""
                        : parseFloat(params.row.positiveThisRead).toFixed(2)
                );
            },
        },
        {
            title: this.L("Forwardcumulant"),
            key: "positiveFlow",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.positiveFlow == null
                        ? ""
                        : parseFloat(params.row.positiveFlow).toFixed(2)
                );
            },
        },
        {
            title: "反向累计流量期初",
            key: "reverseLastRead",
            align: "center",
            width: 150,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.reverseLastRead == null
                        ? ""
                        : parseFloat(params.row.reverseLastRead).toFixed(2)
                );
            },
        },
        {
            title: "反向累计流量期末",
            key: "reverseThisRead",
            align: "center",
            width: 150,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.reverseThisRead == null
                        ? ""
                        : parseFloat(params.row.reverseThisRead).toFixed(2)
                );
            },
        },
        {
            title: this.L("Reversecumulation"),
            key: "reverseFlow",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.reverseFlow == null
                        ? ""
                        : parseFloat(params.row.reverseFlow).toFixed(2)
                );
            },
        },
        {
            title: this.L("PhValue"),
            key: "pH",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pH == null
                        ? ""
                        : parseFloat(params.row.pH).toFixed(3)
                );
            },
        },
        {
            title: this.L("Residualchlorine"),
            key: "residualchlorine",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.residualchlorine == null
                        ? ""
                        : parseFloat(params.row.residualchlorine).toFixed(3)
                );
            },
        },
        {
            title: this.L("Turbidity"),
            key: "turbidity",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.turbidity == null
                        ? ""
                        : parseFloat(params.row.turbidity).toFixed(3)
                );
            },
        },
        {
            title: this.L("PressureValue"),
            key: "pressValue",
            align: "center",
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.pressValue == null
                        ? ""
                        : parseFloat(params.row.pressValue).toFixed(3)
                );
            },
        },
    ];
    //过滤电参数
    getparams(params: number) {
        this.usebar.resize();
        this.usebar.clear();
        this.paramscolumns = [];
        let legend = [];
        let xAxis = [];
        let series = [];
        switch (params) {
            case 1://正反累计用量
                this.paramstype = 1;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" ||
                        ele.key == "deviceNo" ||
                        ele.key == "gatherTime" ||
                        ele.key == "areaId" ||
                        ele.key == "positiveFlow" ||
                        ele.key == "reverseFlow" ||
                        ele.key == "positiveThisRead" ||
                        ele.key == "positiveLastRead" ||
                        ele.key == "reverseThisRead" ||
                        ele.key == "reverseLastRead"
                })
                legend = ['正向累计用量', '反向累计用量'];
                let ibdata = [];
                let icdata = [];
                this.$store.state.waterparams.list.forEach((ele) => {
                    xAxis.push(Moment(ele.gatherTime).format("HH:mm"));
                    ibdata.push(ele.positiveFlow == null ? 0 : ele.positiveFlow);
                    icdata.push(ele.reverseFlow == null ? 0 : ele.reverseFlow);
                });
                series.push({ data: ibdata, name: '正向累计用量', type: 'line' });
                series.push({ data: icdata, name: '反向累计用量', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 2://瞬时流量 
                this.paramstype = 2;
                legend = ['瞬时流量'];
                let vadata = [];
                this.$store.state.waterparams.list.forEach((ele) => {
                    xAxis.push(Moment(ele.gatherTime).format("HH:mm"));
                    vadata.push(ele.instantaneousFlowRate == null ? 0 : ele.instantaneousFlowRate);
                });
                series.push({ data: vadata, name: '瞬时流量', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" ||
                        ele.key == "deviceNo" ||
                        ele.key == "gatherTime" ||
                        ele.key == "areaId" ||
                        ele.key == "instantaneousFlowRate"
                })
                break;
            case 3://PH值
                this.paramstype = 3;
                legend = ['PH值'];
                let eptdata = [];
                this.$store.state.waterparams.list.forEach((ele) => {
                    xAxis.push(Moment(ele.gatherTime).format("HH:mm"));
                    eptdata.push(ele.pH == null ? 0 : ele.pH);
                });
                series.push({ data: eptdata, name: 'PH值', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" ||
                        ele.key == "deviceNo" ||
                        ele.key == "gatherTime" ||
                        ele.key == "areaId" ||
                        ele.key == "pH"
                })
                break;
            case 4://余氯
                this.paramstype = 4;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" ||
                        ele.key == "deviceNo" ||
                        ele.key == "gatherTime" ||
                        ele.key == "areaId" ||
                        ele.key == "residualchlorine"
                })
                legend = ['余氯'];
                let ptdata = [];
                this.$store.state.waterparams.list.forEach((ele) => {
                    xAxis.push(Moment(ele.gatherTime).format("HH:mm"));
                    ptdata.push(ele.residualchlorine == null ? 0 : ele.residualchlorine);
                });
                series.push({ data: ptdata, name: '余氯', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 5://浊度
                this.paramstype = 5;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" ||
                        ele.key == "deviceNo" ||
                        ele.key == "gatherTime" ||
                        ele.key == "areaId" ||
                        ele.key == "turbidity"
                })
                legend = ['浊度'];
                let iahrdata = [];
                this.$store.state.waterparams.list.forEach((ele) => {
                    xAxis.push(Moment(ele.gatherTime).format("HH:mm"));
                    iahrdata.push(ele.turbidity == null ? 0 : ele.turbidity);
                });
                series.push({ data: iahrdata, name: '浊度', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            case 6://压力值
                this.paramstype = 6;
                this.paramscolumns = this.columns.filter((ele) => {
                    return ele.key == "index" ||
                        ele.key == "deviceNo" ||
                        ele.key == "gatherTime" ||
                        ele.key == "areaId" ||
                        ele.key == "pressValue"
                })
                legend = ['压力值'];
                let pftdata = [];
                this.$store.state.waterparams.list.forEach((ele) => {
                    xAxis.push(Moment(ele.gatherTime).format("HH:mm"));
                    pftdata.push(ele.pressValue == null ? 0 : ele.pressValue);
                });
                series.push({ data: pftdata, name: '压力值', type: 'line' });
                this.usebar.setOption(this.$data.baroption(legend, xAxis, series));
                break;
            default:
                this.paramscolumns = this.columns;
                break;
        }
        //this.getpage(params);
    }
    changdate(val) {
        this.pagerequest.startTime = val;
        this.pagerequest.pageSize = 1;
        this.getpage(this.paramstype)
    }
    async created() {
        this.pagerequest.startTime = Moment().format("YYYY-MM-DD ");
        this.pagerequest.sortBy = "gatherTime";
        this.pagerequest.descending = false;
        this.$store.commit("waterparams/setPageSize", 50);
    }

    data() {
        return {
            pageSizeOpts: [50, 100, 300, 600, 1000],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
            datepicker: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
            //柱形图参数
            baroption(legend, xAxis, series) {
                return {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "line", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    legend: {
                        data: legend,
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: xAxis,
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                        },
                    ],
                    series: series,
                };
            },
        };
    }
    mounted() {
        if (window.innerHeight > 800) {
            this.height = window.innerHeight - 500;
            (document.getElementById("echarts") as HTMLDivElement).style.height = "300px";
        } else {
            this.height = window.innerHeight - 560;
            (document.getElementById("echarts") as HTMLDivElement).style.height =
                "200px";
        }
        this.usebar = echarts.init(
            document.getElementById("echarts") as HTMLDivElement
        );
        //自动缩放
        window.addEventListener("resize", () => {
            this.usebar.resize();
        });
        this.getparams(this.paramstype);
    }
}
